class MaterialSeasonalityVisualization extends HTMLElement {
  constructor() {
    super();
    this.colorOptionImages = this.getColorOptionImages();
    this._onVariantChange = this.handleVariantChanged.bind(this);
  }

  getProductForm() {
    const productId = this.dataset.productId;
    if (!productId) return null;
    return document.querySelector(
      `form[is="product-form"][id^="product-form-${productId}-"]`
    );
  }

  connectedCallback() {
    const productForm = this.getProductForm();
    if (productForm) {
      productForm.addEventListener("variant:change", this._onVariantChange);
    }
  }

  handleVariantChanged(e) {
    const variant = e.detail?.variant;
    if (!variant || !this.colorOptionImages) return;

    const optionPosition = this.colorOptionImages.optionPosition;
    const colorValue = variant[`option${optionPosition}`];
    if (!colorValue) return;

    const currentColorOptionImage = this.colorOptionImages.colorsWithImages?.find(
      (item) => item.colorName === colorValue
    );
    const imageUrl = currentColorOptionImage?.imageUrl?.trim();
    const imageEl = this.querySelector(".material-seasonality-visualization__image");

    if (imageEl && imageUrl) {
      imageEl.src = imageUrl;
      imageEl.removeAttribute("srcset");
      imageEl.removeAttribute("sizes");
    }
  }

  getColorOptionImages() {
    const colorOptionImagesScript = this.querySelector("script[data-color-option-images]");
    try {
      return JSON.parse(colorOptionImagesScript?.textContent?.trim() || "{}");
    } catch (error) {
      console.error("Error parsing color option images", error);
      return null;
    }
  }

  disconnectedCallback() {
    const productForm = this.getProductForm();
    productForm?.removeEventListener("variant:change", this._onVariantChange);
  }
}

customElements.define("material-seasonality-visualization", MaterialSeasonalityVisualization);
